import React from 'react';
import ReactDOM from 'react-dom';
import { DcBaseComponent } from '@deleteagency/dc';
import { getParamsFromQueryString } from 'project/general/js/url-helper';
import { FilterService } from 'components/filters/js/filter-service';
import { SearchInput } from './search-input';
import { Counter } from 'components/filters/js/counter';
import { LoadMore } from 'components/filters/js/load-more';
import { NewsList } from 'components/news-filter/js/news-list';
import { SearchList } from 'components/search-page/js/search-list';

export default class SearchComponent extends DcBaseComponent {
    constructor(...args) {
        super(...args);
        this.cards = document.getElementById('search-content');
        this.moreBtn = document.getElementById('search-btn');
        this.noResults = document.getElementById('search-no-results');
        this.totalCount = this.element.getAttribute('data-total-search-count');
    }

    static getNamespace() {
        return 'search';
    }

    onInit() {
        const list = [];
        const content = this.cards.cloneNode(true).innerHTML;
        const startItemsCount = this.cards.querySelectorAll('.search-page__item').length;
        const searchPhrase = 'lazyloading';
        const replacePhrase = 'lazyload';
        const result = content.replaceAll(searchPhrase, replacePhrase);
        list.push(result);

        const moreBtn = this.moreBtn !== null;
        const noResults = this.noResults !== null;
        if (moreBtn) {
            this.moreBtn.remove();
        }
        if (noResults) {
            this.noResults.remove();
        }
        const itemsNum = noResults ? 0 : 1;
        const searhParamsFromUrl =
            window.location.search !== ''
                ? getParamsFromQueryString(window.location.search.split('?')[1])
                : {};

        Object.keys(searhParamsFromUrl).forEach((key) => {
            searhParamsFromUrl[key] = searhParamsFromUrl[key].replaceAll('+', ' ');
        })
        const requiredParams = {};
        this.options.filters
            ?.filter((item) => item.isRequired === true)
            ?.forEach((filter) => {
                requiredParams[filter.name] = filter.defaultValue;
            });
        const textbox = [
            {
                type: 'TextBox',
                isRequired: false,
                name: 's',
                placeholderText: 'Search',
            },
        ];
        ReactDOM.render(
            <FilterService
                endpoint={'/wp-json/fla/v1/search'}
                options={searhParamsFromUrl}
                takeFirstFromApi={false}
                requiredParams={requiredParams}
                startCollection={list}
                startLoadMore={moreBtn}
                itemsNum={itemsNum}
            >
                <SearchInput existedFilters={textbox} />

                <SearchList startCount={startItemsCount} totalCount={this.totalCount} />
                <LoadMore />
            </FilterService>,
            this.element
        );
    }
}

/*
<Counter mockup={this.options.listHeadingTextTemplate} /> */
